export function heroHeadingAnimation() {
    Splitting({
        target: '.title-animation',
        by: 'lines'
    });
    setTimeout(function () {
        $(".title-animation").addClass("animate");
    }, 500);
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroHeadingAnimation.js